// eslint-disable-next-line
enum CheckoutPageUrl {
  TRAVELLER = '/checkout/traveller',
  CUSTOMER = '/checkout/customer',
  CONFIRMATION = '/checkout/confirmation'
}

export default CheckoutPageUrl;
